import {
  AfterViewInit,
  Directive,
  inject,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { AoSharedDataService } from '../../service/ao-shared-data.service';

/**
 * @Deprecated:: Use  MapAbstract instead from shared-ao
 */
@Directive()
export class AbstractMapComponent implements AfterViewInit {
  protected dataService = inject(AoSharedDataService);

  @ViewChild('map') map: GoogleMap;

  // Traffic part
  private _buttonTraffic = this.getButtonTraffic();
  private _isTrafficDisplayed = false;
  private _trafficLayout: google.maps.TrafficLayer =
    new google.maps.TrafficLayer();

  protected _onIdleEvent = () => {};

  public options: WritableSignal<google.maps.MapOptions> = signal({
    center: new google.maps.LatLng(49.8157635, 6.1315139999999815),
  });

  constructor() {
    this.options.update((options) => {
      return {
        ...options,
        mapId: this.dataService.getCurrentGmapsThemeId(),
      };
    });
  }

  ngAfterViewInit() {
    google.maps.event.addListenerOnce(this.map.googleMap, 'idle', () => {
      this._onIdleEvent();
      this._enableTraffic();
    });
  }

  private _enableTraffic(): void {
    if (!this.map) {
      return;
    }
    this._buttonTraffic.addEventListener('click', () => {
      if (!this._isTrafficDisplayed && this.map.googleMap) {
        this._buttonTraffic.style.fontWeight = 'bold';
        this._trafficLayout.setMap(this.map.googleMap);
        this._isTrafficDisplayed = true;
        return;
      }
      this._buttonTraffic.style.fontWeight = 'normal';
      this._trafficLayout.setMap(null);
      this._isTrafficDisplayed = false;
    });
    this.map.googleMap.controls[google.maps.ControlPosition.TOP_LEFT].push(
      this._buttonTraffic,
    );
  }

  private getButtonTraffic(): HTMLElement {
    const button = document.createElement('button');
    this.applyButtonStyle(button);
    button.innerHTML = 'Trafic';
    button.style.marginTop = '10px';
    button.style.marginLeft = '-10px';
    button.style.borderBottomRightRadius = '2px';
    button.style.borderTopRightRadius = '2px';
    button.style.minWidth = '50px';
    return button;
  }

  protected applyButtonStyle(button: HTMLElement) {
    button.style.background = 'none padding-box rgb(255, 255, 255)';
    button.style.display = 'table-cell';
    button.style.border = '0px';
    button.style.margin = '0px';
    button.style.padding = '0px 17px';
    button.style.textTransform = 'none';
    button.style.position = 'absolute';
    button.style.cursor = 'pointer';
    button.style.userSelect = 'none';
    button.style.direction = 'ltr';
    button.style.overflow = 'hidden';
    button.style.textAlign = 'center';
    button.style.height = '40px';
    button.style.verticalAlign = 'middle';
    button.style.color = 'rgb(86, 86, 86)';
    button.style.fontFamily = 'Roboto, Arial, sans-serif';
    button.style.fontSize = '18px';
    button.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
  }
}
